"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Properties"));

var _amb2 = require("./amb.Helper");

var _amb3 = _interopRequireDefault(require("./amb.Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Controls the flow of subscription-related (subscribe, resubscribe, unsubscribe) commands
 * @param commandQueue  the queue to hold commands to process.
 */
var SubscriptionCommandSender = function SubscriptionCommandSender(commandQueue, tokenManager) {
  var CommandModes = {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe"
  };
  var HTTP_STATUS_ACCEPTED = 202;
  var HTTP_STATUS_TOO_MANY_REQUESTS = 429;
  var maxTimeInterval = 5 * 60 * 1000;
  /* 5 minutes in milliseconds */

  var LOGGER = new _amb3.default('amb.SubscriptionCommandSender');
  registerToTokenAvailabilityListener();
  var stopping = !_amb.default.subscribeCommandsFlow.enable;
  var timerObject = null;

  function _clamp(val, minLimit, maxLimit) {
    return Math.min(maxLimit, Math.max(minLimit, val));
  }

  function getTokenCount() {
    return _clamp(tokenManager.getTokenCount(), 0, _amb.default.subscribeCommandsFlow.maxInflight);
  }

  function isBucketFull() {
    return tokenManager.getTokenCount() >= _amb.default.subscribeCommandsFlow.maxInflight;
  }

  function registerToTokenAvailabilityListener() {
    tokenManager.addTokenAvailabilityListener(function () {
      processQueue();
    });
  }

  function restartTimer() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (force || (0, _amb2.isNil)(timerObject)) {
      var timeInterval = _clamp(_amb.default.subscribeCommandsFlow.maxWait, 0, maxTimeInterval);

      LOGGER.debug("restartTimer - force: " + force + ", timerObject : " + timerObject + ", timeInterval : " + timeInterval);
      stopTimer();
      timerObject = setTimeout(function () {
        onTimer();
      }, timeInterval);
    }
  }

  function stopTimer() {
    if (!(0, _amb2.isNil)(timerObject)) {
      LOGGER.debug("stopTimer");
      clearTimeout(timerObject);
      timerObject = null;
    }
  }

  function signalStop() {
    LOGGER.debug("signalStop - stopping : " + stopping);

    if (!stopping) {
      stopping = true;
      stopTimer();
      commandQueue.clear();
    }
  }

  function getRetryDelay() {
    var delay = parseInt(_amb.default.subscribeCommandsFlow.retryDelay.min);
    delay = _clamp(delay, 0, maxTimeInterval);
    return delay;
  }

  function scheduleRetry(channel, triesLeft, mode, retryDelay) {
    LOGGER.debug("scheduleRetry - channel : " + channel.getName() + ", triesLeft : " + triesLeft + ", mode : " + mode);
    var retryMessage;
    var newRetryDelay = getNewRetryDelay(retryDelay);

    switch (mode) {
      case CommandModes.SUBSCRIBE:
        {
          retryMessage = function retryMessage() {
            return enqueueSubscribe(channel, triesLeft, newRetryDelay);
          };

          break;
        }

      case CommandModes.UNSUBSCRIBE:
        {
          retryMessage = function retryMessage() {
            return enqueueUnsubscribe(channel, triesLeft, newRetryDelay);
          };

          break;
        }
    }

    if (!(0, _amb2.isNil)(retryMessage)) setTimeout(retryMessage, retryDelay);
  }

  function onResponse(response, channel, mode, triesLeft, retryDelay) {
    LOGGER.debug("onResponse - response ".concat(JSON.stringify(response), ", channel ").concat(JSON.stringify(channel), ", mode : ").concat(mode, ", \n\t\t\ttriesLeft ").concat(triesLeft, ", stopping : ").concat(stopping, ", tokenCount : ").concat(tokenManager.getTokenCount(), ", isBucketFull - ").concat(isBucketFull(), ", retryDelay - ").concat(retryDelay));

    if (!stopping) {
      triesLeft = triesLeft - 1;
      if (isBucketFull()) stopTimer();
      if (triesLeft > 0 && isRetriable(response)) scheduleRetry(channel, triesLeft, mode, retryDelay);else channel.subscriptionCallback(response);
      processQueue();
    } else channel.subscriptionCallback(response);
  }

  function getNewRetryDelay(retryDelay) {
    return _clamp(_amb.default.subscribeCommandsFlow.retryDelay.increaseFactor * retryDelay, _amb.default.subscribeCommandsFlow.retryDelay.min, _amb.default.subscribeCommandsFlow.retryDelay.max);
  }

  function onTimer() {
    timerObject = null;
    LOGGER.debug("onTimer - stopping : " + stopping);

    if (!stopping) {
      tokenManager.refillTokens();
      processQueue();
    }
  }

  function addItemToQueue(item) {
    LOGGER.debug("addItemToQueue - item : " + item);

    if (commandQueue.enqueue(item)) {
      processQueue();
      return true;
    }

    return false;
  }

  function enqueueSubscribe(channel) {
    var triesLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var retryDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getRetryDelay();
    LOGGER.debug("enqueueSubscribe - channel: " + channel.getName() + ", triesLeft : " + triesLeft + ", stopping : " + stopping + ", retryDelay : " + retryDelay);

    if (!stopping) {
      if ((0, _amb2.isObject)(channel)) {
        if ((0, _amb2.isNil)(triesLeft)) triesLeft = 1 + Math.floor(_amb.default.subscribeCommandsFlow.retries);

        if (triesLeft > 0) {
          var item = function item() {
            LOGGER.debug("enqueueSubscribe - inside the item execution. Calling channel._subscribeToCometD - channel: " + channel.getName() + ", triesLeft : " + triesLeft);

            channel._subscribeToCometD(function (resp) {
              return onResponse(resp, channel, CommandModes.SUBSCRIBE, triesLeft, retryDelay);
            });
          };

          return addItemToQueue(item);
        }
      }
    }

    return false;
  }

  function enqueueUnsubscribe(channel) {
    var triesLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var retryDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getRetryDelay();
    LOGGER.debug("enqueueUnsubscribe - channel: " + channel.getName() + ", triesLeft : " + triesLeft + ", stopping : " + stopping + ", retryDelay : " + retryDelay);

    if (!stopping) {
      if ((0, _amb2.isObject)(channel)) {
        if ((0, _amb2.isNil)(triesLeft)) triesLeft = 1 + Math.floor(_amb.default.subscribeCommandsFlow.retries);

        if (triesLeft > 0) {
          var item = function item() {
            channel._unsubscribeFromCometD(function (resp) {
              return onResponse(resp, channel, CommandModes.UNSUBSCRIBE, triesLeft, retryDelay);
            });
          };

          return addItemToQueue(item);
        }
      }
    }

    return false;
  }

  function isRetriable(response) {
    LOGGER.debug("isRetriable - response : " + response);

    if (response && response.ext) {
      var isRejected = response.ext['rejected_by_glide'];

      if (isRejected) {
        var statusCode = parseInt(response.ext['glide.amb.reply.status.code']);
        LOGGER.addWarnMessage("isRetriable - rejected_by_glide : " + isRejected + ", glide.amb.reply.status.code : " + statusCode);
        if (!isNaN(statusCode)) return statusCode == HTTP_STATUS_TOO_MANY_REQUESTS || statusCode == HTTP_STATUS_ACCEPTED;
      }
    }

    LOGGER.debug("isRetriable -  " + false);
    return false;
  }

  function processQueue() {
    var numberToProcess = Math.min(commandQueue.getSize(), getTokenCount());
    LOGGER.debug("processQueue - numberToProcess : " + numberToProcess);

    if (numberToProcess > 0) {
      var itemsToRun = commandQueue.dequeueMultiple(numberToProcess);
      itemsToRun.forEach(function (item) {
        return (0, _amb2.isNil)(item) || item();
      });
      restartTimer(false); // false: don't push the timer farther away if already running.
    }
  }

  return {
    /**
     * Adds a request to subscribe to the specified channel.
     * @param channel  the channel to subscribe
     * @returns  true if accepted; false if there's insufficient room
     */
    subscribeToChannel: function subscribeToChannel(channel) {
      LOGGER.debug("subscribeToChannel - to : " + channel.getName());
      return enqueueSubscribe(channel);
    },

    /**
     * Adds a request to unsubscribe to the specified channel.
     * @param channel  the channel to unsubscribe
     * @returns  true if accepted; false if there's insufficient room
     */
    unsubscribeToChannel: function unsubscribeToChannel(channel) {
      LOGGER.debug("unsubscribeToChannel - from : " + channel.getName());
      return enqueueUnsubscribe(channel);
    },

    /**
     * Signals this instance to stop.
     */
    stop: function stop() {
      LOGGER.debug("stop");
      signalStop();
    },

    /**
     * Whether this instance is stopped or stopping.
     * @returns  true if stopped or stopping; otherwise false.
     */
    isStopping: function isStopping() {
      return stopping;
    },
    getQueue: function getQueue() {
      return commandQueue;
    },
    isBucketEmpty: function isBucketEmpty() {
      return !isBucketFull();
    },
    getTimerObject: function getTimerObject() {
      return timerObject;
    },
    getTokenCountFromTokenManager: function getTokenCountFromTokenManager() {
      return tokenManager.getTokenCount();
    }
  };
};

var _default = SubscriptionCommandSender;
exports.default = _default;